module.exports = __webpack_public_path__ + "media/images/Icon-card-parking-972f9490a463c68eb4dd6b6b39103e22.svg";